import { deleteData, getData, patchData, postData } from "../api/api";

export type VpnProtocol =
  | "ANYCONNECT"
  | "FORTINET"
  | "GLOBALPROTECT"
  | "PULSE"
  | "NETWORK_CONNECT"
  | "ARRAY"
  | "F5";

export const VPN_PROTOCOLS: { value: VpnProtocol; label: string }[] = [
  { value: "ANYCONNECT", label: "Cisco AnyConnect" },
  { value: "FORTINET", label: "Fortinet SSL VPN" },
  { value: "GLOBALPROTECT", label: "Palo Alto GlobalProtect" },
  { value: "PULSE", label: "Pulse / Ivanti Connect Secure" },
  { value: "NETWORK_CONNECT", label: "Juniper Network Connect" },
  { value: "ARRAY", label: "Array Networks" },
  { value: "F5", label: "F5 BIG-IP" },
];

export type VpnProfileStatus = {
  connected: boolean;
  since?: string | null;
  lastUsed?: string | null;
  lastError?: string | null;
};

export type VpnUsageRef = { id: string; name: string };

export type VpnProfile = {
  id: string;
  name: string;
  description?: string | null;
  enabled: boolean;
  protocol: VpnProtocol;
  server: string;
  port?: number | null;
  username: string;
  passwordSet: boolean;
  authGroup?: string | null;
  serverCertPin?: string | null;
  otpRequired?: boolean;
  acceptUntrustedCertificate?: boolean;
  status?: VpnProfileStatus;
  dataAdaptors?: VpnUsageRef[];
  openApiCatalogs?: VpnUsageRef[];
  createdDate?: string;
  lastModifiedDate?: string;
};

export type VpnProfileSaveRequest = {
  name?: string;
  description?: string;
  enabled?: boolean;
  protocol?: VpnProtocol;
  server?: string;
  /** 0 clears it (then 443, or the port in the server address, is used). */
  port?: number;
  username?: string;
  /** Write-only; blank on update keeps the stored password. */
  password?: string;
  authGroup?: string;
  serverCertPin?: string;
  otpRequired?: boolean;
  acceptUntrustedCertificate?: boolean;
};

export type VpnProfileSummary = { id: string; name: string; protocol: VpnProtocol; otpRequired?: boolean };

const BASE = "/admin/vpn-profiles";

export const adminVpnProfileService = {
  list: () => getData(BASE) as Promise<VpnProfile[]>,
  summaries: () => getData(`${BASE}/summaries`) as Promise<VpnProfileSummary[]>,
  get: (id: string) => getData(`${BASE}/${id}`) as Promise<VpnProfile>,
  create: (body: VpnProfileSaveRequest) => postData(BASE, body) as Promise<VpnProfile>,
  update: (id: string, body: VpnProfileSaveRequest) => patchData(`${BASE}/${id}`, body) as Promise<VpnProfile>,
  remove: (id: string) => deleteData(`${BASE}/${id}`),
  test: (id: string) => postData(`${BASE}/${id}/test`, {}) as Promise<{ ok: boolean; message: string }>,
  status: (id: string) => getData(`${BASE}/${id}/status`) as Promise<VpnProfileStatus>,
  disconnect: (id: string) => postData(`${BASE}/${id}/disconnect`, {}),
};
